module.exports = __webpack_public_path__ + "static/media/ipec logo transparent_1663072992167.676ad942.jpg";